import React, { useState } from "react";
import { 
	RCCGrid,
	RCCTextArea,
	RCCInputMask,
	RCCInput,
	RCCTooltip,
	RCCButton, 
	RCCSelectOptionsCard
} from "react-common-components";
import DateTimePickerRange from "src/components/DateTimePickerRange";
import LovSectors from "src/components/Lov/Sectors";
import Select from "src/components/Select";
import { useTranslation } from "src/context/Translations/context";
import {formatMinutesInHours} from "src/utils/formartHourMinutes";
import { ActionSituation } from "../../interface";
import { FormFieldsOnRight } from "../../styles";
import { IFormSimplifiedFields } from "./interface";

const FormSimplifiedFields: React.FC<IFormSimplifiedFields> = ({
	selectedAction,
	isDisabled,
	isAdd,
	isCopy,
	controlAddOrChange,
	errorsAddOrChange,
	registerAddOrChange,
	setValueAddOrChange,
	modalShowPostponements
}) => {
	const { translate } = useTranslation();
	const [showDuration, setShowDuration] = useState(selectedAction.inb001Tipo?.toString() === "2");

	const onChangeTypeSelect = (value: string) => {
		if(value === "2"){
			setShowDuration(true);
			return;
		}
		setShowDuration(false);
	};

	const onBlurDuration = (e: any) => {
		const {value} = e.target;
		const splitDuration = value.toString().split(":");

		const hours = splitDuration[0];
		const minutes = splitDuration[1];

		if(!Number.isNaN(parseFloat(minutes))){
			const inb001Duracao = parseFloat(hours) * 60 + parseFloat(minutes);
			const format = formatMinutesInHours(inb001Duracao, 4);
			setValueAddOrChange("inb001Duracao", format);
			return;
		}

		const inb001Duracao = parseFloat(hours) * 60;
		const format = formatMinutesInHours(inb001Duracao, 4);
		setValueAddOrChange("inb001Duracao", format);
	};

	return(
		<>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<RCCSelectOptionsCard
					control={controlAddOrChange}
					name="inb001Tipo"
					label=" "
					defaultValue={selectedAction.inb001Tipo ? selectedAction.inb001Tipo.toString() : "1"}
					options={[{
						label: translate("Ação"),
						value: "1"
					},{
						label: translate("Tarefa"),
						value: "2"
					}]}
					onChange={onChangeTypeSelect}
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<RCCTextArea 
					register={registerAddOrChange}
					name="inb001Titulo"
					label={translate("Título")}
					maxLength={200}
					defaultValue={isCopy ? `(${translate("CÓPIA")}) ${selectedAction.inb001Titulo}` : selectedAction.inb001Titulo}
					error={errorsAddOrChange.inb001Titulo}
					required
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
				alignItems="flex-end"
			>
				<div style={{display: "flex", flex: 1}}>
					<DateTimePickerRange 
						type="datePicker"
						label={translate("Data prevista")}
						labelSeparator={translate("até")}
						nameInit="inb001Dtinicio"
						nameEnd="inb001Dtfim"
						defaultValueEnd={selectedAction.inb001Dtfim ? new Date(selectedAction.inb001Dtfim) : new Date()}
						defaultValueInit={selectedAction.inb001Dtinicio ? new Date(selectedAction.inb001Dtinicio) : new Date()}
						control={controlAddOrChange}
						error={errorsAddOrChange.inb001Dtfim || errorsAddOrChange.inb001Dtinicio}
						required
						props={{
							datePicker: {
								disabled: isDisabled
							}
						}}
					/>
				</div>
				{!isAdd && selectedAction.intbb003.length > 0 && (
					<RCCTooltip
						color="red"
						text={translate("Postergações")}
					>
						<RCCButton 
							icon={{
								name: "info"
							}}
							color="red"
							styleInline="margin-bottom: 8px;"
							onClick={() => {
								if(modalShowPostponements)
									modalShowPostponements?.current?.openModalActionShowPostponements(selectedAction.inb001Id, `${selectedAction.inb001Codigo} - ${selectedAction.inb001Titulo}`, selectedAction.intbb003);	
							}}
						/>
					</RCCTooltip>
				)}
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<RCCGrid
					container
					item
					xs={12}
					sm={6}
				>
					<Select 
						control={controlAddOrChange}
						name="inb001Situacao"
						label={translate("Situação")}
						defaultValue={isAdd ? "0" : selectedAction.inb001Situacao?.toString()}
						options={isAdd || (
							selectedAction.inb001Situacao?.toString() === ActionSituation.DRAFT || 
							selectedAction.inb001Situacao?.toString() === ActionSituation.NOT_STARTED
						) ? [{
								label: translate("Não iniciada"),
								value: ActionSituation.NOT_STARTED
							},{
								label: translate("Rascunho"),
								value: ActionSituation.DRAFT
							}] : [{
								label: translate("Não iniciada"),
								value: ActionSituation.NOT_STARTED
							},{
								label: translate("Rascunho"),
								value: ActionSituation.DRAFT
							},{
								label: translate("Cancelada"),
								value: ActionSituation.CANCELED
							},{
								label: translate("Concluída"),
								value: ActionSituation.FINISHED
							},{
								label: translate("Em andamento"),
								value: ActionSituation.IN_PROGRESS
							}]}
						required
						disabled={isDisabled || ((!isAdd || (selectedAction.inb001Situacao?.toString() === ActionSituation.FINISHED || selectedAction.inb001Situacao?.toString() === ActionSituation.CANCELED)) &&  !(
							selectedAction.inb001Situacao?.toString() === ActionSituation.DRAFT || 
							selectedAction.inb001Situacao?.toString() === ActionSituation.NOT_STARTED
						))}
					/>
	
				</RCCGrid>
				{showDuration && (
					<RCCGrid
						container
						item
						xs={12}
						sm={6}
					>
						<RCCInputMask 
							name="inb001Duracao" 
							control={controlAddOrChange}
							label={`${translate("Duração")} (${translate("horas")}:${translate("minutos")})`}
							defaultValue={formatMinutesInHours(selectedAction.inb001Duracao, 4)} 
							disabled={isDisabled}	
							format="####:##"
							error={errorsAddOrChange.inb001Duracao}
							required
							styleInline={FormFieldsOnRight}
							onBlurCapture={(e: any) => {
								onBlurDuration(e);
							}}
						/>
					</RCCGrid>
				)}
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<LovSectors 
					control={controlAddOrChange}
					name="inb001Taa001Id"
					label={translate("Setor")}
					defaultValue={selectedAction.inb001Taa001Id && (selectedAction.inb001Taa001Nome ? { value: String(selectedAction.inb001Taa001Id), label: selectedAction.inb001Taa001Nome } : selectedAction.inb001Taa001Id.toString())}
					isClearable
					isCreatable
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<RCCInput
					name="inb001Onde"
					label={`${translate("Onde")}?`}
					register={registerAddOrChange}
					maxLength={120}
					defaultValue={selectedAction.inb001Onde}
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<RCCTextArea
					name="inb001Como"
					label={`${translate("Como")}?`}
					maxLength={4000}
					register={registerAddOrChange}
					defaultValue={selectedAction.inb001Como}
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={6}
			>
				<RCCTextArea
					name="inb001Motivo"
					label={`${translate("Por quê")}?`}
					register={registerAddOrChange}
					defaultValue={selectedAction.inb001Motivo}
					maxLength={400}
					disabled={isDisabled}
				/>
			</RCCGrid>
		</>
	);};

export default FormSimplifiedFields;
